import { Injectable } from "@angular/core"
import { NavigationEnd, Router } from "@angular/router"
import { BehaviorSubject } from "rxjs"
import { FeatureFlagsService } from "./feature-flags.service"

// FIXME: delete this service after the search redesign epic is done
@Injectable({ providedIn: "root" })
export class SearchRedesignService {
    isRedesignSearchPage$ = new BehaviorSubject<boolean>(false)

    constructor(
        private router: Router,
        private featureFlagsService: FeatureFlagsService
    ) {
        this.isRedesignSearchPage$.next(
            this.isRootSearchPage(this.router.url) &&
                this.featureFlagsService.searchRedesignFeatureFlag
        )

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.isRedesignSearchPage$.next(
                    this.isRootSearchPage(event.urlAfterRedirects) &&
                        this.featureFlagsService.searchRedesignFeatureFlag
                )
            }
        })
    }

    private isRootSearchPage(url: string): boolean {
        const cleanUrl = url.split("?")[0].split("#")[0].replace(/\/$/, "")
        return cleanUrl === "/search" || cleanUrl === "/add-on/search"
    }
}
